import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-6">About OrderFlow</h2>
          <p className="text-gray-600 mb-4">
            Welcome to OrderFlow, your trusted partner for fast and reliable delivery across Kenya. We believe everyone
            deserves quick access to the food and goods they love, wherever they are.
          </p>
          <p className="text-gray-600 mb-6">
            Our growing network connects you with the best local restaurants, everyday essentials, and more, from popular
            favorites to hidden gems. Whether you're ordering lunch, restocking your pantry, or sending a gift across town,
            we bring convenience straight to your door.
          </p>
          <p className="text-gray-600">
            With real-time tracking, dependable riders, and a growing network of local restaurants and stores, OrderFlow is
            more than a delivery app—it's how Kenya gets what it needs, fast.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;